import { Col, Row, Text, Title } from 'ui';

export type P = {
  additionalText?: string;
  description: string;
  href: string;
  title: string;
};

const HelpItem = ({ additionalText, description, href, title }: P) => (
  <Row>
    <Col>
      <Title level={4} marginBottom>
        {title}
      </Title>
      <Text>
        {additionalText}
        {/* TODO: create external link component */}
        <a href={href} rel="noreferrer" target="_blank">
          {description}
        </a>
      </Text>
    </Col>
  </Row>
);

export default HelpItem;
